import React, {Component} from 'react'
import classnames from "classnames"
import { connect } from "react-redux";
import Loader from '../shared/Loader'

import failed from '../../img/failed@3x.png'
import time from '../../img/icons/time.svg'
import baseStyles from 'custom/base.styl';

import {testFailedComplete} from '../../store/test/actions'

class LanguageTestFailed extends Component {
  componentDidMount() {
    this.props.testFailedComplete()
  }

  render () {
    const {test} = this.props

    if (test.isFetching) {
      return <Loader absolute />
    }

    const hasScore = test.testSteps.length > 0
    const timeOut =  test.failedStep && test.failedStep === 'timeout'

    if (timeOut) {
      return (
        <div className={classnames(baseStyles.content_board, baseStyles.centered, baseStyles.testing)} key='test-failed-timeout'>
          <img className={baseStyles.content_board__icon} src={time} alt="" width="72px" />
          <div className={baseStyles.header}><h1 className={baseStyles.title}>Oops...</h1></div>

          <p className={classnames(baseStyles.danger_title)}>
            The time to complete the test is over. <br />
            Unfortunately, you do not have enough score <br />
            to move forward.
          </p>

          <p className={classnames(baseStyles.content_board__text, baseStyles.light_text)}>Good luck in your new endeavors.</p>
        </div>
      )
    } else {
      return (
        <div className={classnames(baseStyles.content_board, baseStyles.centered, baseStyles.testing)} key='test-failed-failed'>
          <img className={baseStyles.content_board__icon} src={failed} alt="" width="75px" />
          <div className={baseStyles.header}><h1 className={baseStyles.title}>You failed the test :(</h1></div>
          {/* {hasScore && <p className={classnames(baseStyles.content_board__text, baseStyles.light_text, baseStyles.mb_0)}><b>You scored:</b></p>}
          {hasScore && <h2 className={classnames(baseStyles.title, baseStyles.danger_title)}>{test.score} from {test.stepsCount}</h2>} */}

          <p className={baseStyles.content_board__text}>
            Unfortunately, we cannot offer you the position at the moment as you <br/> have failed to pass our selection criteria.
          </p>
          <p className={baseStyles.content_board__text}>
            We do not share the information about correct/wrong answers in <br/> order to eliminate multiple applications from a candidate.
          </p>

          <p className={classnames(baseStyles.content_board__text, baseStyles.light_text)}>
            Thank you for your interest and good luck in future endeavours.
          </p>
        </div>
      )
    }
  }
}

export default connect(
  (state) => ({
    test: state.test
  }),
  (dispatch) => ({
    testFailedComplete: () => dispatch(testFailedComplete())
  })
)(LanguageTestFailed)



// WEBPACK FOOTER //
// ./src/components/LanguageTest/PageLanguageTestFailed.js